import React from 'react';
import { useTranslation } from 'react-i18next';

import Spinner from '../Spinner/Spinner';
import Button from '../Button/Button';
import styles from '../SignIn/SignIn.module.scss';

import fpStyles from './ForgotPassword.module.scss';

interface Props {
  values: { email: string };
  errors: { email?: string; form?: string };
  emailError: string;
  submitting: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleRecoveryByUsername: () => void;
  recoveryLoading: boolean;
}

export const EmailVerificationForm: React.FC<Props> = ({
  values,
  errors,
  emailError,
  submitting,
  handleChange,
  handleSubmit,
  handleRecoveryByUsername,
  recoveryLoading,
}) => {
  const { t } = useTranslation('account');

  return (
    <>
      <h1 className={styles.cardTitle}>{t('reset.forgot_password_username')}</h1>
      <p className={styles.cardSubtitle}>{t('reset.enter_email_assist')}</p>
      <form onSubmit={handleSubmit} noValidate>
        <div className={styles.field}>
          <label htmlFor="forgot-email" className={styles.fieldLabel}>
            {t('reset.email')}
            <span className={styles.required} aria-hidden>
              *
            </span>
          </label>
          <div className={styles.inputWrap}>
            <input
              id="forgot-email"
              name="email"
              type="email"
              className={styles.input}
              value={values.email}
              onChange={handleChange}
              placeholder={t('reset.email_placeholder')}
              required
              aria-invalid={!!errors.email || !!emailError}
            />
          </div>
          <p className={styles.helperError} role="alert" style={{ visibility: (errors.email || emailError) ? 'visible' : 'hidden' }}>
            {errors.email || emailError || '\u00A0'}
          </p>
        </div>
        <Button type="submit" color="primary" fullWidth size="large" disabled={submitting} label={t('reset.send_code')} />
      </form>
      <div
        className={fpStyles.recoveryLink}
        onClick={handleRecoveryByUsername}
        style={{ opacity: !values.email ? 0.5 : 1, pointerEvents: !values.email ? 'none' : 'auto' }}
      >
        {recoveryLoading ? <Spinner size="small" /> : t('reset.dont_know_username')}
      </div>
    </>
  );
};
